import React, { useEffect } from "react";
import { CartServerSide } from "./api_response";

export const ExtraContext = React.createContext();

const ExtraStuffProvider = (props) => {
  const { orders } = React.useContext(CartServerSide);
  const [size, setSize] = React.useState("");
  const [amount, setAmount] = React.useState(1);
  const [crust, setCrust] = React.useState("");
  const [delivery, setDelivery] = React.useState("");
  const [flip, setFlip] = React.useState(false);
  const [paymentMethod, setPaymentMethod] = React.useState("");
  const [edit, setEdit] = React.useState(false);

  const get_payment_method = () => {
    let radios = document.getElementsByName("payment");
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) {
        setPaymentMethod(radios[i].value);
        if (radios[i].value === "In Cash") {
          setFlip(false);
        } else {
          setFlip(true);
        }
        break;
      }
    }
  };

  const handleIncrease = () => {
    setAmount(amount + 1);
  };

  const handleDecrease = () => {
    if (amount === 1) {
      setAmount(1);
    } else {
      setAmount(amount - 1);
    }
  };

  const get_crust = () => {
    let radios = document.getElementsByName("crust");
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) {
        setCrust(radios[i].value);
        break;
      }
    }
  };

  const get_size = () => {
    let radios = document.getElementsByName("size");
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) {
        setSize(radios[i].value);
        break;
      }
    }
  };

  const get_delivery = () => {
    let radios = document.getElementsByName("deliveryOption");
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) {
        setDelivery(radios[i].value);
        break;
      }
    }
  };

  const [authFilters, setAuthFilters] = React.useState({
    username_login: "",
    username_register: "",
    password_login: "",
    password_register: "",
    email: "",
    Name: "",
    lastName: "",
    City: "",
    ZIP: "",
    Phone: "",
    address1: "",
    address2: "",
    Note: "",
  });

  let { email, Name, lastName, City, ZIP, Phone, address1 } = authFilters;

  let is_empty =
    !email || !Name || !lastName || !City || !ZIP || !Phone || !address1;

  const handleForm = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setAuthFilters({ ...authFilters, [name]: value });
  };

  const [alert, setAlert] = React.useState({ show: false });
  const [gif, setGif] = React.useState(false);

  const handleAlert = ({ type, text }) => {
    setAlert({ show: true, type, text });
    setTimeout(() => {
      setAlert({ show: false });
    }, 4000);
  };

  const disabledScroll = (arg1) => {
    let isVisible = arg1
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "visible");
    return isVisible;
  };

  useEffect(() => {
    disabledScroll(gif);
  }, [gif]);





  const [pagination, setPagination] = React.useState(0);
  const handlePagination = (id) => {
    setPagination(id);
  };

  React.useEffect(() => {
    if (orders.length === 1) {
      handleAlert({
        show: true,
        type: "success",
        text: "Now you can view your orders, by navigating into My Orders page",
      });
    }
  }, []);

  return (
    <ExtraContext.Provider
      value={{
        amount,
        crust,
        delivery,
        size,
        setCrust,
        setSize,
        setAmount,
        handleIncrease,
        handleDecrease,
        get_crust,
        get_size,
        get_delivery,
        authFilters,
        handleForm,
        alert,
        handleAlert,
        get_payment_method,
        flip,
        paymentMethod,
        is_empty,
        gif,
        setGif,
        edit,
        setEdit,
        pagination,
        handlePagination,
      }}
    >
      {props.children}
    </ExtraContext.Provider>
  );
};

export { ExtraStuffProvider as default };
